import React from 'react';
import { BRANDING } from '../config';

function InsightsScheduleCard() {
  const schedules = [
    {
      label: 'Daily Report',
      description: 'AI compliance analysis of the last 24 hours of inventory logs.',
      schedule: 'Every morning at 9:00 AM ET',
      icon: '📊',
    },
    {
      label: 'Weekly Report',
      description: 'Strategic intelligence report with trends, patterns, and recommendations.',
      schedule: 'Every Monday at 9:00 AM ET',
      icon: '📈',
    },
  ];

  return (
    <div style={{ background: '#fff', borderRadius: '8px', border: '1px solid #ddd', overflow: 'hidden' }}>
      <div style={{ background: BRANDING.primaryColor, color: '#fff', padding: '16px 20px' }}>
        <h3 style={{ margin: 0, fontSize: '16px' }}>AI Insights Schedule</h3>
      </div>
      <div style={{ padding: '16px 20px' }}>
        {schedules.map((s, i) => (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
              padding: '12px 0',
              borderBottom: i < schedules.length - 1 ? '1px solid #eee' : 'none',
            }}
          >
            <div style={{ fontSize: '24px', lineHeight: 1 }}>{s.icon}</div>
            <div>
              <div style={{ fontWeight: '600', color: '#333', fontSize: '14px' }}>{s.label}</div>
              <div style={{ color: '#666', fontSize: '12px', marginTop: '2px' }}>{s.description}</div>
              <div style={{ color: BRANDING.primaryColor, fontSize: '12px', marginTop: '4px', fontWeight: '600' }}>
                {s.schedule}
              </div>
            </div>
          </div>
        ))}
        <p style={{ margin: '12px 0 0 0', fontSize: '11px', color: '#999' }}>
          Reports are delivered via email to all admin users and stored in the system for review.
          Scheduling is managed via pg_cron in Supabase.
        </p>
      </div>
    </div>
  );
}

export default InsightsScheduleCard;
